/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Praxis
 */
export class Praxis {
    /**
     *
     * @type {string}
     * @memberof Praxis
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Praxis
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Praxis
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Praxis
     */
    merchantId: string;
    /**
     *
     * @type {string}
     * @memberof Praxis
     */
    secretKey: string;
    /**
     *
     * @type {string}
     * @memberof Praxis
     */
    applicationKey: string;
    /**
     *
     * @type {string}
     * @memberof Praxis
     */
    encryptedEmailDomain: string;
    /**
     *
     * @type {boolean}
     * @memberof Praxis
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Praxis
     */
    autoApprove: boolean;
    /**
     *
     * @type {string}
     * @memberof Praxis
     */
    version: string;
    /**
     *
     * @type {boolean}
     * @memberof Praxis
     */
    amountFromDB: boolean;
}
